'use client';

import { type ReactNode } from 'react';

import { DeviceProvider } from '@/contexts/DeviceContext';
import { WhitelabelConfigProvider } from '@/contexts/WhitelabelConfigContext';
import { Toaster } from '@/libs';
import { DatadogLogsProvider } from '@/providers/DatadogLogsProvider';
import { DatadogRumProvider } from '@/providers/DatadogRumProvider';
import { GlobalErrorListeners } from '@/providers/GlobalErrorListeners';
import { HumanPassProvider } from '@/providers/HumanPassProvider';
import { RootErrorBoundary } from '@/providers/RootErrorBoundary';
import { VersionSkewWatcher } from '@/providers/VersionSkewWatcher';
import type { WhitelabelConfigResponse } from '@/types/models/WhitelabelConfig';

import { AudioProviderWrapper } from './AudioProviderWrapper';

type ProvidersProps = {
  children: ReactNode;
  initialWhitelabelConfig: WhitelabelConfigResponse | null;
};

export const Providers = ({ children, initialWhitelabelConfig }: ProvidersProps) => {
  return (
    <RootErrorBoundary>
      <WhitelabelConfigProvider initialConfig={initialWhitelabelConfig}>
        <DatadogLogsProvider>
          <DatadogRumProvider>
            <GlobalErrorListeners />
            <VersionSkewWatcher />
            <HumanPassProvider>
              <AudioProviderWrapper>
                <DeviceProvider>
                  {children}
                  <Toaster position="top-center" richColors closeButton />
                </DeviceProvider>
              </AudioProviderWrapper>
            </HumanPassProvider>
          </DatadogRumProvider>
        </DatadogLogsProvider>
      </WhitelabelConfigProvider>
    </RootErrorBoundary>
  );
};
